import { useCallback } from "react";
import { useOrganisation } from "./useOrganisation";
import { useUser } from "./useUser";

export const useLogout = () => {

    const { setUser, setTemporaryToken, setCollaborators } = useUser();
    const { setOrganisation } = useOrganisation();

    const onLogout = useCallback(()=> {
        // Clear user data
        setUser(null);
        setTemporaryToken('');
        setCollaborators([]);

        // Clear organisation data
        setOrganisation(null);

        // Clear tout le storage
        localStorage.clear();
    }, [
        setUser,
        setTemporaryToken,
        setCollaborators,
        setOrganisation,
    ]);

    return { onLogout }
};
